import { useMutation } from '@tanstack/react-query';

import type {
  CreateOrderParams,
  CreateOrderResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateOrderMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CreateOrderParams }) =>
      HttpClient.request<CreateOrderResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });
